// src/dataAdmin/index.js — admin data-management small clusters (moved
// VERBATIM from admin.html, FE-breakup slice 5; bundled to dist/dataAdmin.js):
//   - historical-upload section UI shell (toggle + status paint — the upload
//     pipeline itself lives in src/uploads/historical.js, which calls
//     showHistoricalUploadStatus back via its window binding below)
//   - addon KPI rates admin (loadAddonRates / saveAddonRates)
//   - demo line management (v79.9)
//   - run rate management (v79.12)
//   - export tab (initExportTab)
//
// Free names resolved from the page at runtime: DB, showToast, escapeHtml,
// ALL_STORES, XLSX, Uploads.* (module global). Cluster state
// (DEMO_LINE_COUNTRIES, _runRateEntries, _runRateEditingId) is module-private
// (audited: zero external references).

// Toggle the collapsed "First-time setup" historical bootstrap section.
// Most days the user never expands this — it's a one-time action.
function toggleHistoricalSection() {
  const sect = document.getElementById('historicalSection');
  const icon = document.getElementById('historicalToggleIcon');
  if (!sect) return;
  if (sect.style.display === 'none') {
    sect.style.display = 'block';
    if (icon) icon.textContent = 'Hide';
  } else {
    sect.style.display = 'none';
    if (icon) icon.textContent = 'Show';
  }
}

// v92.0: handleSalesDrop removed — legacy Sales tab deleted

// v92.0: handleSalesFile removed — legacy Sales tab deleted

// v92.0: parseDailySalesSheet removed — legacy Sales tab deleted

// v79.1: re-run the parse using current state (accepted extras + dismissed set).
// Called on initial parse, after [Use this] click, and after [Skip] click.
// v92.0: rebuildSalesFromState removed — legacy Sales tab deleted

// v79.1: User clicked [Use this] — adopt the file column as the missing store.
// Re-parses with the extra mapping in place; the row count + preview update.
// v92.0: acceptSalesSuggestion removed — legacy Sales tab deleted

// v92.0: dismissSalesSuggestion removed — legacy Sales tab deleted

// ── HISTORICAL SALES UPLOAD (one-time setup) ────────────────
// Reads ONLY the "Last Year by Store" sheet. Uses the "Date LY" column
// (the actual prior-year date) as the storage key — NOT "Date TY" as
// the previous design did. Writes rows with date in the prior year, so
// they're indistinguishable from regular sales rows once stored.

// v90.0: handleHistoricalDrop → Uploads.historical.handleDrop

// v90.0: handleHistoricalFile → Uploads.historical.handleFile

// v90.0: parseHistoricalSalesSheet → internal helper inside Uploads.historical

// v90.0: rebuildHistoricalFromState → internal helper inside Uploads.historical

// v90.0: acceptHistoricalSuggestion → Uploads.historical.acceptSuggestion

// v90.0: dismissHistoricalSuggestion → Uploads.historical.dismissSuggestion

// v91.0: parseMatrixSheet → Uploads.shared.parseMatrixSheet (deduplicated from src/uploads/shared.js)

// ── Upload-status display helpers (post-v92.0: only historical remains) ──
// When an upload is missing some expected stores AND the file has
// columns we couldn't map, surface "Did you mean…?" suggestions
// using the same fuzzy-match scoring already used for staff matching.
//
// Used by: budget upload (parseTargetRows), daily sales upload
// (parseDailySalesSheet), historical sales upload (Uploads.historical via shared.js).

// v91.0: STORE_SUGGESTION_MIN_SCORE removed — now lives in src/uploads/shared.js (Uploads.shared.STORE_SUGGESTION_MIN_SCORE)

// v91.0: findStoreColumnSuggestions → Uploads.shared.findStoreColumnSuggestions (deduplicated from src/uploads/shared.js)

// v91.0: renderStoreSuggestionCards → Uploads.shared.renderStoreSuggestionCards (deduplicated from src/uploads/shared.js)

// v92.0: saveSalesToDB removed — legacy Sales tab deleted

// v90.0: saveHistoricalToDB → Uploads.historical.save

// v92.0: clearSalesPreview removed — legacy Sales tab deleted

// v90.0: clearHistoricalPreview → Uploads.historical.clearPreview

// v92.0: showSalesUploadStatus removed — legacy Sales tab deleted

function showHistoricalUploadStatus(msg, type) {
  const el = document.getElementById('historicalUploadStatus');
  const inner = document.getElementById('historicalUploadStatusInner');
  if (!el || !inner) return;
  el.style.display = 'block';
  const colors = {
    success: {bg:'var(--adm-ok-pale)',color:'var(--ok-deep)',border:'var(--adm-ok-line)'},
    error:   {bg:'var(--adm-danger-pale)',color:'var(--danger-deep)',border:'var(--adm-danger-line)'},
    info:    {bg:'var(--adm-purple-pale)',color:'var(--adm-purple-text)',border:'var(--adm-purple-line)'},
  };
  const c = colors[type] || colors.info;
  inner.style.cssText = `background:${c.bg};color:${c.color};border:1px solid ${c.border};padding:12px 14px;border-radius:10px;font-size:13px`;
  inner.textContent = msg;
}

// ════════════════════════════════════════════════════════════
// ADDON KPI ADMIN (v79.3)
// ────────────────────────────────────────────────────────────
// Two responsibilities:
//   1. Edit the global rate config (5 percentages + 4 unit prices,
//      one row in addon_rates). Demo target is just a percentage —
//      its price comes from each store's currently-set demo line.
//   2. Upload daily actuals (.xlsx with one sheet per category).
// ════════════════════════════════════════════════════════════

async function loadAddonRates() {
  const status = document.getElementById('addonRatesStatus');
  if (status) { status.textContent = 'Loading…'; status.style.color = 'var(--sub)'; }
  try {
    const r = await DB.addon_rates.get();
    if (!r) { if (status) status.textContent = 'No config row — saving will create one.'; return; }
    // Convert decimal rates (0.015) into percentages (1.5) for display.
    document.getElementById('addonRateDemo').value      = (Number(r.demo_target_pct)    * 100).toFixed(2);
    document.getElementById('addonRateBatPct').value    = (Number(r.batteries_pct)      * 100).toFixed(2);
    document.getElementById('addonRateBatPrice').value  = Number(r.batteries_price).toFixed(2);
    document.getElementById('addonRateWrapPct').value   = (Number(r.gift_wrap_pct)      * 100).toFixed(2);
    document.getElementById('addonRateWrapPrice').value = Number(r.gift_wrap_price).toFixed(2);
    document.getElementById('addonRateBagPct').value    = (Number(r.reusable_bag_pct)   * 100).toFixed(2);
    document.getElementById('addonRateBagPrice').value  = Number(r.reusable_bag_price).toFixed(2);
    document.getElementById('addonRateCardPct').value   = (Number(r.gift_cards_pct)     * 100).toFixed(2);
    document.getElementById('addonRateCardPrice').value = Number(r.gift_cards_price).toFixed(2);
    if (status) {
      status.textContent = 'Loaded' + (r.updated_at ? ' (last updated ' + new Date(r.updated_at).toLocaleString() + ')' : '');
      status.style.color = 'var(--sub)';
    }
  } catch (e) {
    if (status) { status.textContent = 'Failed to load: ' + e.message; status.style.color = 'var(--adm-red-text)'; }
  }
}

async function saveAddonRates() {
  const status = document.getElementById('addonRatesStatus');
  // Read percentages as 0–100, convert to 0–1 for storage
  const pct = id => {
    const v = parseFloat(document.getElementById(id).value);
    return isNaN(v) ? null : v / 100;
  };
  const num = id => {
    const v = parseFloat(document.getElementById(id).value);
    return isNaN(v) ? null : v;
  };
  const payload = {
    demo_target_pct:    pct('addonRateDemo'),
    batteries_pct:      pct('addonRateBatPct'),
    batteries_price:    num('addonRateBatPrice'),
    gift_wrap_pct:      pct('addonRateWrapPct'),
    gift_wrap_price:    num('addonRateWrapPrice'),
    reusable_bag_pct:   pct('addonRateBagPct'),
    reusable_bag_price: num('addonRateBagPrice'),
    gift_cards_pct:     pct('addonRateCardPct'),
    gift_cards_price:   num('addonRateCardPrice'),
  };
  // Validation
  const missing = Object.entries(payload).filter(([k, v]) => v == null || v < 0).map(([k]) => k);
  if (missing.length) {
    status.textContent = 'Fix invalid/missing fields: ' + missing.join(', ');
    status.style.color = 'var(--adm-red-text)';
    return;
  }
  status.textContent = 'Saving…';
  status.style.color = 'var(--sub)';
  try {
    await DB.addon_rates.save(payload);
    status.textContent = 'Saved.';
    status.style.color = 'var(--ok)';
    showToast('Add-on rates saved', 'success');
  } catch (e) {
    status.textContent = 'Save failed: ' + e.message;
    status.style.color = 'var(--adm-red-text)';
  }
}

// ── Demo line management (v79.9) ─────────────────────────
// Admin UI for setting demo lines at store / country / company scope.
// Hierarchy at lookup time (in /api/kpi worker handler): store-specific
// wins, then country, then company.
//
// Country values are pulled from the actual stores → areas join. We
// fetch them lazily on first scope='country' selection rather than at
// page load, since admins primarily set store-level entries.

const DEMO_LINE_COUNTRIES = ['ELC - UAE', 'ELC - Qatar'];   // matches areas.country values

function isoWeekToInputValue(year, week) {
  // <input type="week"> uses 'YYYY-Www' format with zero-padded week.
  return year + '-W' + String(week).padStart(2, '0');
}
function inputValueToIsoWeek(value) {
  // Parse 'YYYY-Www' back to {year, week}.
  if (!value) return null;
  const m = String(value).match(/^(\d{4})-W(\d{1,2})$/);
  if (!m) return null;
  return { year: Number(m[1]), week: Number(m[2]) };
}
function currentIsoWeekValue() {
  // Same algorithm as the worker — Thursday-of-week determines isoYear.
  const dt = new Date();
  const utcDt = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()));
  const dow = ((utcDt.getUTCDay() + 6) % 7) + 1;
  const thurs = new Date(utcDt);
  thurs.setUTCDate(utcDt.getUTCDate() + 4 - dow);
  const isoYear = thurs.getUTCFullYear();
  const jan4 = new Date(Date.UTC(isoYear, 0, 4));
  const jan4Dow = ((jan4.getUTCDay() + 6) % 7) + 1;
  const week1Mon = new Date(jan4);
  week1Mon.setUTCDate(jan4.getUTCDate() - jan4Dow + 1);
  const week = Math.floor((thurs - week1Mon) / (7 * 86400000)) + 1;
  return isoWeekToInputValue(isoYear, week);
}

function onDemoLineScopeChange() {
  const scope = document.getElementById('demoLineScope').value;
  const targetSel = document.getElementById('demoLineTargetSelect');
  const targetRow = document.getElementById('demoLineTargetRow');
  if (!targetSel || !targetRow) return;   // v136.8: null-safe (the box may not be on screen)
  // Re-populate options based on scope.
  if (scope === 'store') {
    targetRow.style.display = 'grid';
    targetSel.innerHTML = '<option value="">— select —</option>' +
      (ALL_STORES || []).map(s => '<option value="' + escapeHtml(s) + '">' + escapeHtml(s) + '</option>').join('');
  } else if (scope === 'country') {
    targetRow.style.display = 'grid';
    targetSel.innerHTML = '<option value="">— select —</option>' +
      DEMO_LINE_COUNTRIES.map(c => '<option value="' + escapeHtml(c) + '">' + escapeHtml(c) + '</option>').join('');
  } else if (scope === 'company') {
    // For company scope the target is fixed — don't show the dropdown
    // (avoids the impression of choice). The save handler hardcodes 'COMPANY'.
    targetRow.style.display = 'none';
    targetSel.value = 'COMPANY';
  }
  loadExistingDemoLine();
}

function initDemoLineCard() {
  // Set the week input to current ISO week (default).
  const weekInput = document.getElementById('demoLineWeek');
  if (weekInput && !weekInput.value) weekInput.value = currentIsoWeekValue();
  onDemoLineScopeChange();   // populate dropdown for default 'store' scope
}

async function loadExistingDemoLine() {
  const scope = document.getElementById('demoLineScope').value;
  const targetSel = document.getElementById('demoLineTargetSelect');
  const target = scope === 'company' ? 'COMPANY' : targetSel.value;
  const weekVal = document.getElementById('demoLineWeek').value;
  const existing = document.getElementById('demoLineExisting');
  const itemInput = document.getElementById('demoLineItemName');
  const priceInput = document.getElementById('demoLineRetailPrice');

  if (!target || !weekVal) {
    existing.textContent = '';
    return;
  }
  const wk = inputValueToIsoWeek(weekVal);
  if (!wk) { existing.textContent = ''; return; }

  // Fetch all entries for this target, then filter to this week.
  // demo_line.list returns rows for the named "store" — which we're
  // overloading to mean store/country/'COMPANY'.
  try {
    const rows = await DB.demo_line.list(target);
    const match = (rows || []).find(r =>
      Number(r.iso_year) === wk.year && Number(r.iso_week) === wk.week
    );
    if (match) {
      existing.innerHTML = 'Currently set: <strong translate="no">' + escapeHtml(match.item_name) + '</strong> @ <strong>' +
        Number(match.retail_price).toFixed(2) + '</strong> ' +
        '<span style="font-size:11px;color:var(--sub)">(set by ' + escapeHtml(match.set_by || 'unknown') + ')</span>';
      itemInput.value  = match.item_name || '';
      priceInput.value = match.retail_price != null ? Number(match.retail_price) : '';
    } else {
      existing.textContent = 'Not set for this week.';
      itemInput.value  = '';
      priceInput.value = '';
    }
  } catch (e) {
    existing.textContent = 'Failed to load: ' + e.message;
  }
}

async function saveDemoLineAdmin() {
  const status = document.getElementById('demoLineAdminStatus');
  const scope = document.getElementById('demoLineScope').value;
  const target = scope === 'company' ? 'COMPANY' : document.getElementById('demoLineTargetSelect').value;
  const weekVal = document.getElementById('demoLineWeek').value;
  const itemName = document.getElementById('demoLineItemName').value.trim();
  const priceRaw = document.getElementById('demoLineRetailPrice').value;

  // Validation
  if (!target) { status.textContent = 'Pick a target first.'; status.style.color = 'var(--adm-red-text)'; return; }
  if (!weekVal) { status.textContent = 'Pick a week first.'; status.style.color = 'var(--adm-red-text)'; return; }
  if (!itemName) { status.textContent = 'Item name required.'; status.style.color = 'var(--adm-red-text)'; return; }
  const price = Number(priceRaw);
  if (!isFinite(price) || price <= 0) {
    status.textContent = 'Retail price must be a positive number.';
    status.style.color = 'var(--adm-red-text)';
    return;
  }
  const wk = inputValueToIsoWeek(weekVal);
  if (!wk) { status.textContent = 'Invalid week format.'; status.style.color = 'var(--adm-red-text)'; return; }

  status.textContent = 'Saving…';
  status.style.color = 'var(--sub)';
  try {
    await DB.demo_line.set({
      scope:        scope,
      store:        target,
      iso_year:     wk.year,
      iso_week:     wk.week,
      item_name:    itemName,
      retail_price: price,
    });
    status.textContent = 'Saved.';
    status.style.color = 'var(--ok)';
    showToast('Demo line saved (' + scope + ')', 'success');
    loadExistingDemoLine();   // refresh the "currently set" display
  } catch (e) {
    status.textContent = 'Save failed: ' + e.message;
    status.style.color = 'var(--adm-red-text)';
  }
}

// ── Run rate management (v79.12) ─────────────────────────
// Per-store run-rate scaling for addon KPI targets. Sales targets are
// untouched — only the multiplier inside the addon target formula is
// affected. Used when a store is at a known %-of-normal due to
// disruption (war, refurb, mall closure, etc.).
//
// State:
//   _runRateEntries — cached list of all run-rate rows for the list UI
//   _runRateEditingId — when set, the form is editing an existing row;
//                       Save will PATCH instead of POST.

var _runRateEntries = [];
var _runRateEditingId = null;

function initRunRateCard() {
  // Wire up store dropdown from the global ALL_STORES list.
  var sel = document.getElementById('runRateStore');
  if (sel && sel.options.length <= 1) {
    sel.innerHTML = '<option value="">— select —</option>' +
      (ALL_STORES || []).map(function(s){
        return '<option value="' + escapeHtml(s) + '">' + escapeHtml(s) + '</option>';
      }).join('');
  }
  // Default From to today.
  var fromInput = document.getElementById('runRateFrom');
  if (fromInput && !fromInput.value) {
    var d = new Date();
    fromInput.value = d.getFullYear() + '-' +
      String(d.getMonth()+1).padStart(2,'0') + '-' +
      String(d.getDate()).padStart(2,'0');
  }
  loadRunRateList();
}

async function loadRunRateList() {
  var listEl = document.getElementById('runRateList');
  if (!listEl) return;
  listEl.innerHTML = '<div style="color:var(--sub);font-size:12px">Loading…</div>';
  try {
    _runRateEntries = await DB.run_rate.list();
  } catch (e) {
    listEl.innerHTML = '<div style="color:var(--adm-red-text);font-size:12px">Failed to load: ' + escapeHtml(e.message) + '</div>';
    return;
  }
  if (!_runRateEntries || !_runRateEntries.length) {
    listEl.innerHTML = '<div style="color:var(--sub);font-size:12px;font-style:italic">No run-rate entries. All stores are at 100% (no scaling).</div>';
    return;
  }
  // Render as a simple list of cards. Edit and Delete buttons per entry.
  var today = (function(){
    var d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  })();
  var html = '';
  _runRateEntries.forEach(function(r){
    // Active = no end date OR end date >= today.
    var isActive = !r.effective_to || r.effective_to >= today;
    var isFuture = r.effective_from > today;
    var statusLabel = isFuture
      ? '<span style="color:var(--adm-yellow-text);font-weight:600">Scheduled</span>'
      : isActive
        ? '<span style="color:var(--ok);font-weight:600">Active</span>'
        : '<span style="color:var(--sub)">Ended</span>';
    var rangeLabel = r.effective_from + ' \u2192 ' + (r.effective_to || 'indefinite');
    html += '<div style="border:1px solid var(--border);border-radius:8px;padding:10px 12px;margin-bottom:8px;background:var(--card)">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">' +
        '<div>' +
          '<div style="font-weight:600">' + escapeHtml(r.store) + ' \u2014 <span style="color:var(--text)">' + Number(r.rate_pct) + '%</span></div>' +
          '<div style="font-size:11px;color:var(--sub);margin-top:2px">' + escapeHtml(rangeLabel) + ' \u2022 ' + statusLabel + '</div>' +
          (r.notes ? '<div translate="no" style="font-size:12px;color:var(--sub);margin-top:4px;font-style:italic">' + escapeHtml(r.notes) + '</div>' : '') +   // v135.2: typed notes stay as written
        '</div>' +
        '<div style="display:flex;gap:6px">' +
          '<button onclick="editRunRate(' + r.id + ')" style="background:var(--card);color:var(--sub);border:1px solid var(--border);border-radius:6px;padding:4px 10px;font-size:11px;font-weight:600;cursor:pointer;font-family:inherit">Edit</button>' +
          '<button onclick="deleteRunRate(' + r.id + ', \'' + escapeAttr(r.store) + '\')" style="background:var(--card);color:var(--adm-red-text);border:1px solid var(--adm-danger-line);border-radius:6px;padding:4px 10px;font-size:11px;font-weight:600;cursor:pointer;font-family:inherit">Delete</button>' +
        '</div>' +
      '</div>' +
      '</div>';
  });
  listEl.innerHTML = html;
}

function editRunRate(id) {
  var r = _runRateEntries.find(function(x){ return x.id === id; });
  if (!r) return;
  _runRateEditingId = id;
  document.getElementById('runRateStore').value = r.store;
  document.getElementById('runRateFrom').value  = r.effective_from || '';
  document.getElementById('runRateTo').value    = r.effective_to   || '';
  document.getElementById('runRatePct').value   = r.rate_pct;
  document.getElementById('runRateNotes').value = r.notes || '';
  document.getElementById('runRateStatus').textContent = 'Editing entry #' + id + ' \u2014 click Save to update, or Clear form to cancel.';
  document.getElementById('runRateStatus').style.color = 'var(--adm-yellow-text)';
  // Scroll into view so user sees the form.
  document.getElementById('runRateStore').scrollIntoView({ behavior: 'smooth', block: 'center' });
}

async function deleteRunRate(id, storeName) {
  if (!confirm('Remove run-rate entry for ' + storeName + '? This will revert addon targets to 100% from this entry\u2019s effective range.')) return;
  try {
    await DB.run_rate.remove(id);
    showToast('Run-rate entry removed', 'success');
    // If we were editing this one, clear the form.
    if (_runRateEditingId === id) clearRunRateForm();
    loadRunRateList();
  } catch (e) {
    showToast('Delete failed: ' + e.message, 'error');
  }
}

function clearRunRateForm() {
  _runRateEditingId = null;
  document.getElementById('runRateStore').value = '';
  document.getElementById('runRateTo').value    = '';
  document.getElementById('runRatePct').value   = '';
  document.getElementById('runRateNotes').value = '';
  // Reset From to today.
  var d = new Date();
  document.getElementById('runRateFrom').value = d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  var status = document.getElementById('runRateStatus');
  status.textContent = '';
  status.style.color = 'var(--sub)';
}

async function saveRunRate() {
  var status = document.getElementById('runRateStatus');
  var store = document.getElementById('runRateStore').value;
  var from  = document.getElementById('runRateFrom').value;
  var to    = document.getElementById('runRateTo').value || null;
  var pct   = document.getElementById('runRatePct').value;
  var notes = document.getElementById('runRateNotes').value.trim() || null;

  // Client-side validation. Worker re-validates server-side; this just gives
  // immediate feedback.
  if (!store)  { status.textContent = 'Pick a store.'; status.style.color = 'var(--adm-red-text)'; return; }
  if (!from)   { status.textContent = 'Pick a "From" date.'; status.style.color = 'var(--adm-red-text)'; return; }
  var pctNum = Number(pct);
  if (!isFinite(pctNum) || pctNum < 0 || pctNum > 200) {
    status.textContent = 'Rate % must be between 0 and 200.';
    status.style.color = 'var(--adm-red-text)';
    return;
  }
  if (to && to < from) {
    status.textContent = 'End date must be on or after start date.';
    status.style.color = 'var(--adm-red-text)';
    return;
  }

  status.textContent = 'Saving…';
  status.style.color = 'var(--sub)';
  try {
    var payload = {
      store:          store,
      effective_from: from,
      effective_to:   to,
      rate_pct:       pctNum,
      notes:          notes,
    };
    if (_runRateEditingId) payload.id = _runRateEditingId;
    await DB.run_rate.set(payload);
    status.textContent = _runRateEditingId ? 'Updated.' : 'Saved.';
    status.style.color = 'var(--ok)';
    showToast('Run-rate ' + (_runRateEditingId ? 'updated' : 'saved'), 'success');
    clearRunRateForm();
    loadRunRateList();
  } catch (e) {
    status.textContent = 'Save failed: ' + e.message;
    status.style.color = 'var(--adm-red-text)';
  }
}

// ════════════════════════════════════════════════════════════
// v93.0: Dead-code island removed (486 LOC, 13 functions across 4 sections)
//   - "Daily actuals upload" section (orphaned after v89.0 partial cleanup —
//     handleAddonActualsDrop/save/clear/template were removed in v89.0 but
//     the rest of the chain stayed orphan-alive)
//   - "Add-on actuals template (v79.4)" — stub only after v89.0
//   - "DAILY UPLOAD (v79.7)" section (same orphan-after-v89.0 pattern)
//   - "Daily upload template (v79.7)" — stub only after v89.0
//
// Removed: handleAddonActualsFile, rebuildAddonActualsFromState,
//   findHeaderRow, acceptAddonActualsSuggestion, dismissAddonActualsSuggestion,
//   showAddonActualsStatus, handleDailyUploadFile, rebuildDailyUploadFromState,
//   acceptDailySalesSuggestion, dismissDailySalesSuggestion,
//   acceptDailyAddonSuggestion, dismissDailyAddonSuggestion,
//   showDailyUploadStatus + parsedAddonActuals, addonActualsParseState,
//   ADDON_SHEET_FIELDS, dailyUploadParseState, DAILY_SALES_SHEET_LC,
//   DAILY_ADDON_SHEETS state.
//
// Live upload paths now go entirely through Uploads.{daily,addon,budget,
// historical,shared} in src/uploads/. Inline admin.html upload code is
// limited to HTML markup + onclick wirings.
// ════════════════════════════════════════════════════════════

// ════════════════════════════════════════════════════════════
// EXPORT (v79.7)
// ────────────────────────────────────────────────────────────
// Pulls sales / targets / addon_actuals / daily_notes / demo_lines
// from the worker as JSON for a date range. Builds Excel client-side
// with SheetJS so we don't need server-side xlsx generation.
// ════════════════════════════════════════════════════════════

function initExportTab() {
  // Default date range: this calendar year
  var now = new Date();
  var fromDefault = now.getFullYear() + '-01-01';
  var toDefault = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  var fromEl = document.getElementById('exportFromDate');
  var toEl   = document.getElementById('exportToDate');
  if (fromEl && !fromEl.value) fromEl.value = fromDefault;
  if (toEl   && !toEl.value)   toEl.value   = toDefault;

  // Populate store dropdown from ALL_STORES
  var sel = document.getElementById('exportStoreSelect');
  if (sel && sel.options.length <= 1) {
    var stores = (typeof ALL_STORES !== 'undefined' ? ALL_STORES : [])
      .filter(s => s && s !== 'Retail Relief Managers' && getStoreType(s) !== 'virtual')
      .sort();
    stores.forEach(s => {
      var opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      sel.appendChild(opt);
    });
  }
}

// v101.0: fetchExportData → Uploads.excel.fetchExportData
// Helper: build a single store's tab as an aoa rows array.
// Columns: Day | Date | Sales | Target | vs LY % | Demo Actual | Bat | Wrap | Bag | Cards | Note | Demo Line
// v101.0: buildStoreSheetRows → Uploads.excel.buildStoreSheetRows
// Helper: build a country/total tab with one row per date, summed across stores.
// v101.0: buildAggregateSheetRows → Uploads.excel.buildAggregateSheetRows
// Helper: enumerate all dates from -> to inclusive (YYYY-MM-DD strings).
// v101.0: enumerateDates → Uploads.excel.enumerateDates
// v101.0: downloadStoreExport → Uploads.excel.downloadStoreExport
// v101.0: downloadAllStoresExport → Uploads.excel.downloadAllStoresExport
// v102.0: renderTargetsStatus → Uploads.budget.renderTargetsStatus

// Every moved function stays window-reachable: markup onclick/onchange
// handlers, switchTab's typeof-guarded init calls, row-action strings
// generated by loadRunRateList, and src/uploads/historical.js's cross-bundle
// showHistoricalUploadStatus calls all resolve via window.
window.toggleHistoricalSection = toggleHistoricalSection;
window.showHistoricalUploadStatus = showHistoricalUploadStatus;
window.loadAddonRates = loadAddonRates;
window.saveAddonRates = saveAddonRates;
window.isoWeekToInputValue = isoWeekToInputValue;
window.inputValueToIsoWeek = inputValueToIsoWeek;
window.currentIsoWeekValue = currentIsoWeekValue;
window.onDemoLineScopeChange = onDemoLineScopeChange;
window.initDemoLineCard = initDemoLineCard;
window.loadExistingDemoLine = loadExistingDemoLine;
window.saveDemoLineAdmin = saveDemoLineAdmin;
window.initRunRateCard = initRunRateCard;
window.loadRunRateList = loadRunRateList;
window.editRunRate = editRunRate;
window.deleteRunRate = deleteRunRate;
window.clearRunRateForm = clearRunRateForm;
window.saveRunRate = saveRunRate;
window.initExportTab = initExportTab;
